import React, { useState } from "react";
import Box from "@mui/material/Box";
import { ThemeProvider, createTheme, Typography, Tabs, Tab } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Link as RouterLink } from "react-router-dom";
import Footer from "../Footer";
import atlasPic1 from "./atlas1.jpg";
import atlasPic2 from "./atlas2.jpg";

export default function Atlas_2() {
  const [tabIndex, setTabIndex] = useState(0);

  const theme = createTheme({
    typography: {
      fontFamily: "Helvetica, Arial, sans-serif",
      h1: {
        fontSize: "3rem",
        fontWeight: 200,
        lineHeight: 1.1,
        wordBreak: "break-word",
        overflowWrap: "anywhere",
      },
      body1: {
        fontSize: "1.25rem",
        fontWeight: 200,
        "@media (max-width:600px)": { fontSize: "1.25rem", fontWeight: 300 },
      },
    },
  });

  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isDesktop = useMediaQuery("(min-width:600px)");

  const container80 = { width: "80vw", maxWidth: 1200, boxSizing: "border-box" };
  const imageContainerStyle = {
    width: isDesktop ? "35vw" : "80vw",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    overflow: "hidden",
    marginTop: "2vw",
  };
  const imageStyle = { width: "100%", height: "auto", maxWidth: "100%" };
  const dualImageContainerStyle = {
    display: "flex",
    flexDirection: isDesktop ? "row" : "column",
    justifyContent: "center",
    alignItems: "center",
    gap: isDesktop ? "1rem" : "2vh",
    width: isMobile ? "80vw" : "800px",
    margin: "2vw auto 0",
  };
  const dualImageStyle = {
    width: isDesktop ? "50%" : "100%",
    height: "auto",
    maxWidth: "100%",
  };
  const writingBoxStyle = {
    width: isMobile ? "100vw" : "800px",
    maxWidth: isMobile ? "100vw" : "800px",
    boxSizing: "border-box",
    px: "2rem",
    py: "3rem",
    borderTop: "1px solid black",
    borderBottom: "1px solid black",
    mb: "6vh",
    backgroundColor: "white",
    mx: "auto",
  };
  const writingTextStyle = {
    fontFamily: `Georgia, "Times New Roman", Times, serif`,
    fontSize: "1.15rem",
    fontWeight: 400,
    lineHeight: 1.7,
    textAlign: "justify",
    whiteSpace: "pre-line",
    "& b, & strong": { fontWeight: 700 },
    "& i, & em": { fontStyle: "italic" },
  };

  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        {/* Main content */}
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          flex={1}
          marginTop="5vh"
        >
          {/* Title */}
          <Box sx={{ width: "80vw", maxWidth: 1200, mb: "5vh", textAlign: "center" }}>
            <RouterLink
              to="/writing"
              style={{
                color: "inherit",
                textDecoration: "none",
              }}
            >
              <Typography variant="h1">
                // Atlas <span style={{ fontSize: "0.6em" }}>(#2)</span>
              </Typography>
            </RouterLink>
          </Box>

          {/* Intro text */}
          <Box sx={{ ...container80, mb: "3vh" }}>
            <Typography
              variant="body1"
              sx={{
                lineHeight: 1.5,
                whiteSpace: "pre-line",
                maxWidth: "68ch",
                mx: "auto",
                textAlign: "left",
              }}
            >
              In April 2026 the second edition of {" "}
              <a
                href="https://swiss-atlas.ch/boutique/atlas-n2-la-fabrique-des-futurs/"
                target="_blank"
                rel="noreferrer"
              >
                Atlas
              </a>
              , an independent Fribourg-based magazine, came out, and I had the pleasure of writing an article for it.
            </Typography>
          </Box>
          

           <Box style={imageContainerStyle} mb="0vh">
          <img src={atlasPic1} style={imageStyle} />
        </Box>

          {/* Tabs */}
          <Box
            sx={{
              width: isMobile ? "100vw" : "800px",
              mx: "auto",
              mb: "2vh",
              mt: "2vh",
              boxSizing: "border-box",
            }}
          >
            <Tabs
              value={tabIndex}
              onChange={(e, v) => setTabIndex(v)}
              variant={isMobile ? "fullWidth" : "standard"}
              centered={!isMobile}
              textColor="inherit"
              indicatorColor="primary"
              sx={{
                maxWidth: "100%",
                "& .MuiTab-root": {
                  fontWeight: 400,
                  textTransform: "uppercase",
                  letterSpacing: "0.05em",
                },
              }}
            >
              <Tab label="Français" sx={{ minWidth: 0, flex: 1 }} />
            </Tabs>
          </Box>

          {/* FRANÇAIS */}
          {tabIndex === 0 && (
            <Box sx={writingBoxStyle}>
              <Typography variant="body1" component="div" sx={writingTextStyle}>
                {/* ——— keep your French text here exactly as you have it ——— */}
                <b>post-mortem carousel</b>
                <br /><br />
                Réveil, café, petite promenade digitale. Une routine banale, familière à beaucoup. Je me rassure en disant que c’est pour le travail, mais je sais que c’est plus profond : un réflexe devenu naturel. Les yeux glissent sur les mots, les images ; des environnements qui absorbent l’attention – l’être – se fondent les uns dans les autres au rythme de mouvements des doigts gravés dans la mémoire musculaire, tel un singe se balançant de liane en liane : des gestes désormais intégrés à la nature humaine.
                <br /><br />
                Mais comment un humain est-il censé naviguer d’une scène atroce de guerre – rappel à la misère du monde et à sa propre mortalité – à la banalité d’une photo d’apéro, à du soft-porn déguisé en art, au chat le plus drôle du monde, à une vidéo d’une violence impensable, à un autre chat, à l’érotisme, à son ami qui est diplômé, sans se sentir désorienté ?
                <br /><br />
                Le temps court, aujourd’hui. Ce défilé d’informations se tient dans nos poches, dans un objet beau et lisse qui donne l’impression de combler tout désir. J’accepterais l’argument selon lequel l’algorithme serait l’équivalent de mon libre arbitre – si seulement la violence, l’extrême, la joie ou la peur n’en étaient pas les formes les plus lucratives. Car c’est bien de profit qu’il s’agit. Les environnements digitaux, ces mondes avec leurs propres règles et formes, sont créés par des entreprises pour être regardés à travers des smartphones-fenêtres dans le seul but d’en extraire de l’argent. Des entreprises bien réelles qui, par leur consommation d’énergie et de matière, influencent notre monde – celui des arbres, des rires, des pleurs – là où je vis.
<br /><br />
                Je me demande donc, en tant que personne cherchant à naviguer aisément dans ses alentours, ce qui se passe là-dedans. Ce glissement permanent entre réel et écran n’est pas neutre. À force de déléguer nos gestes et émotions aux machines, quelque chose se vide. Ce n’est plus seulement notre attention qu’on draine, mais une forme de vitalité. Et pendant que les plateformes perfectionnent leurs promesses d’efficacité, d’innovation et de sécurité, le monde matériel s’épuise en silence, plié à l’ordre du digital.
<br /><br />
                Chaque clic, chaque scroll, chaque photo stockée a un poids. Derrière l’illusion du nuage, ce sont des serveurs qui chauffent, des rivières qui refroidissent, des métaux arrachés à la terre. L’écologie du numérique n’est pas métaphorique : c’est une chaîne d’extraction, de circulation et de déchets aussi concrète que celle du pétrole.
<br /><br />
                Les géants du numérique rêvent d’un monde où plus rien ne leur échappe. Si <i>The Matrix</i> dénonçait l’absurdité d’un système qui transforme les humains en batteries, nos entreprises d’aujourd’hui tentent littéralement de le construire. Meta n’a pas inventé un univers parallèle pour nous libérer, mais pour prolonger la captation : chaque geste, chaque émotion, chaque trace de présence se convertit en donnée exploitable. Ils aimeraient posséder la Matrix, si seulement elle existait déjà.
<br /><br />
                On alimente cette machine par fatigue, par habitude, par besoin d’appartenance. Et puisque la sortie n’existe pas, il reste à apprendre à vivre à l’intérieur du cadavre du monde. À l’accepter. Le taxidermiste ne nie pas la mort : il la regarde, la comprend, il essaie d’en préserver la forme. Je crois que c’est tout ce qu’on peut faire, aujourd’hui – habiter la ruine, reconnaître sa beauté, et continuer à créer, même si tout sent déjà la décomposition. Non pas par espoir, mais par lucidité : parce que c’est encore là, dans la matière morte, que bat la seule forme de vie qu’il nous reste.

              </Typography>
            </Box>
          )}


        <Box style={imageContainerStyle} mb="2vh">
          <img src={atlasPic2} style={imageStyle} />
        </Box>
        </Box>

        {/* Footer */}
        <Footer />
      </Box>
    </ThemeProvider>
  );
}